module.exports = __webpack_public_path__ + "img/no_wifi.7522a479.png";